import { useEffect, useMemo, useState } from 'react';
import { ChartMode, ChartPalette, currentChartMode, readChartPalette } from './chartTheme';

/**
 * Track the light/dark mode the app is painted in.
 *
 * Reads the `dark` class ThemeContext toggles on <html> rather than the React
 * context, so a chart works in any tree — including the page-level tests and
 * modals that render outside ThemeProvider — and still repaints on toggle.
 */
export function useChartMode(): ChartMode {
    const [mode, setMode] = useState<ChartMode>(currentChartMode);

    useEffect(() => {
        if (typeof MutationObserver === 'undefined') return undefined;
        const observer = new MutationObserver(() => setMode(currentChartMode()));
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        setMode(currentChartMode());
        return () => observer.disconnect();
    }, []);

    return mode;
}

/** The active mode's palette — re-read whenever the theme toggles. */
export function useChartPalette(): ChartPalette {
    const mode = useChartMode();
    return useMemo(() => readChartPalette(mode), [mode]);
}

export default useChartMode;
